import {
    GREEN_STATUS,
    RED_STATUS,
    YELLOW_STATUS
} from "../../../../utils/config";

import styles from "./RiskLevel.module.sass";

const RISK_LEVELS = {
    low: {
        level: "Below Optimal",
        status: YELLOW_STATUS
    },
    meduim: {
        level: "At Optimal",
        status: GREEN_STATUS
    },
    high: {
        level: "Above Optimal",
        status: RED_STATUS
    },
};

const RiskLevel = ({
    optimalLeverageLoop,
    netAPY,
    leverage,
    optimalLeverageMul
}) => {

    const getRiskLevel = () => {
        let riskLevel = RISK_LEVELS.meduim;

        if (netAPY < optimalLeverageLoop && leverage > optimalLeverageMul) {
            riskLevel = RISK_LEVELS.high;
        } else if (netAPY < optimalLeverageLoop) {
            riskLevel = RISK_LEVELS.low;
        }

        return (
            <div className={riskLevel.status}>{riskLevel.level}</div>
        );
    };

    return (
        <div className={styles.riskLevel}>
            <div>Optimal Leverage Level</div>
            <div className={styles.label}>{getRiskLevel()}</div>
        </div>
    );
};

export default RiskLevel;
